import { register } from './config'
import collect from './collect'

if (window.__portraitCollector && window.__portraitCollector.__config) {
  // 用户已经在全局预设了配置，直接启动脚本
  register(window.__portraitCollector.__config)
  collect()
  window.__portraitCollector.launch = collect
} else {
  // 用户未预设配置，需要等待用户手动执行
  window.__portraitCollector = {
    config: register,
    launch: collect
  }
}
